var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeteorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "#de4f4f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.64 58.594L0 .53l58.062 54.64a2.42 2.42 0 1 1-3.319 3.526l-.103-.103M46.6 62.7L5.4 18.067l44.623 41.2a2.42 2.42 0 1 1-3.286 3.558l-.137-.136m-8.34.1L10.88 33.15l29.66 27.38c.656.605.696 1.627.092 2.28s-1.627.696-2.28.092l-.092-.1M61.202 42.28L32.616 11.412l30.866 28.586c.654.606.694 1.628.087 2.28s-1.627.693-2.28.087l-.087-.087m-2.467 8.642l-41.38-44.8 44.8 41.38a2.42 2.42 0 1 1-3.286 3.557l-.136-.136m-29.008 9.457L16.7 46.212l14.166 13.026a.81.81 0 0 1 .05 1.14.81.81 0 0 1-1.141.048l-.048-.048M60.18 32.024L47.155 17.858 61.32 30.883c.328.303.35.813.048 1.14a.81.81 0 0 1-1.141.048l-.048-.048"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeteorIcon);
export default __webpack_public_path__ + "static/media/meteor-icon.c79b0501188971d569b6105ae8726d6c.svg";
export { ForwardRef as ReactComponent };